module.exports = __webpack_public_path__ + "img/1000.29b4b338.svg";